import "./themes.scss";

import { useEffect } from "react";

import { useTeamsContext } from "../../../../../_shared/state/TeamsContextProvider";

type PollyTheme = "dark" | "contrast" | "default";

export function useTheme(cardHtml: HTMLElement) {
  const context = useTeamsContext();
  const currentTheme = context.teamsContext.app.theme;

  useEffect(() => {
    const themes: { [key: string]: PollyTheme } = {
      default: "default",
      dark: "dark",
      contrast: "contrast",
    };

    const textInputs = cardHtml.getElementsByClassName("ac-textInput");
    const buttons = cardHtml.getElementsByTagName("button");
    [...Array.from(buttons), ...Array.from(textInputs)].forEach(element => {
      const pollyTheme = themes[currentTheme];
      element.classList.add(pollyTheme ?? "default");
    });

    if (currentTheme === "dark" || currentTheme === "contrast") {
      const numberOfInputs = cardHtml.getElementsByClassName("ac-input-container").length;

      if (numberOfInputs === 1) {
        const multichoiceInputParentContainer = cardHtml
          .getElementsByClassName("ac-multichoiceInput")
          .item(0)?.parentElement?.parentElement?.parentElement;

        if (multichoiceInputParentContainer) {
          multichoiceInputParentContainer.style.padding = "0px";
        }
      }
    }

    // add class to comment boxes
    const commentBoxes = Array.from(textInputs).filter(x => x.tagName === "INPUT");
    commentBoxes.forEach(commentBox => {
      commentBox.classList.add("comment-box");
    });
  }, [cardHtml, currentTheme]);
}
